import {
    type EmojiId,
    type EmojiVisualizerFiles,
    type EmojiVisualizerIsLocked,
    type EmojiVisualizerMetadata,
    type EmojiVisualizerName,
    type EmojiVisualizerNameIsLocked,
    type ExtendedEmoji,
    type SearchResponse,
    type Tag,
} from '@app/client/common/structs';

export const ACTION_SET_USER_EMOJIS = 'ACTION_SET_USER_EMOJIS';
export const ACTION_SET_USER_EXTENDED_EMOJIS = 'ACTION_SET_USER_EXTENDED_EMOJIS';
export const ACTION_SET_CURRENT_USER_EMOJI = 'ACTION_SET_CURRENT_USER_EMOJI';
export const ACTION_SET_CURRENT_USER_EMOJI_SEARCH = 'ACTION_SET_CURRENT_USER_EMOJI_SEARCH';
export const ACTION_SET_CURRENT_EMOJI_TAGS = 'ACTION_SET_CURRENT_EMOJI_TAGS';
export const ACTION_SET_EDITING_EMOJI_TAGS = 'ACTION_SET_EDITING_EMOJI_TAGS';
export const ACTION_SET_LOADING_EMOJIS = 'ACTION_SET_LOADING_EMOJIS';
export const ACTION_SET_LOADING_EMOJI_TAGS = 'ACTION_SET_LOADING_EMOJI_TAGS';
export const ACTION_SET_CURRENT_EMOJI_VISUALIZER_NAME = 'ACTION_SET_CURRENT_EMOJI_VISUALIZER_NAME';
export const ACTION_SET_CURRENT_EMOJI_VISUALIZER_METADATA = 'ACTION_SET_CURRENT_EMOJI_VISUALIZER_METADATA';
export const ACTION_SET_CURRENT_EMOJI_VISUALIZER_FILES = 'ACTION_SET_CURRENT_EMOJI_VISUALIZER_FILES';
export const ACTION_SET_CURRENT_EMOJI_VISUALIZER_URL = 'ACTION_SET_CURRENT_EMOJI_VISUALIZER_URL';
export const ACTION_SET_USER_REMOVED_EMOJIS = 'ACTION_SET_USER_REMOVED_EMOJIS';

export interface UserEmojiState {
    blockedUntil: string | null;
    currentEmoji: EmojiId;
    currentEmojiChainFormat: EmojiId | null;
    currentEmojiMinted: boolean;
    currentEmojiTokenId: number | null;
    currentEmojiSearchResponse: SearchResponse | null;
    currentRhythmScore: number;
    currentGeneration: number;
    editingTags: Tag[];
    emojis: EmojiId[];
    extendedEmojis: ExtendedEmoji[];
    currentFree: boolean;
    loadingEmojis: boolean;
    loadingEmojiTags: boolean;
    tags: Tag[];
    visualizerFiles: EmojiVisualizerFiles | null;
    visualizerName: string | null;
    visualizerMetadata: EmojiVisualizerMetadata | null;
    visualizerUrl: string | null;
    visualizerIsLocked: EmojiVisualizerIsLocked;
    visualizerNameIsLocked: EmojiVisualizerNameIsLocked;
    removedEmojis: EmojiId[]; // Emojis transferred out from this account
}

interface SetUserEmojis {
    type: typeof ACTION_SET_USER_EMOJIS;
    emojis: EmojiId[];
}

interface SetUserExtendedEmojis {
    type: typeof ACTION_SET_USER_EXTENDED_EMOJIS;
    emojis: ExtendedEmoji[];
}

interface SetCurrentUserEmoji {
    type: typeof ACTION_SET_CURRENT_USER_EMOJI;
    currentEmoji: EmojiId;
}
interface SetCurrentUserEmojiSearch {
    type: typeof ACTION_SET_CURRENT_USER_EMOJI_SEARCH;
    currentEmojiSearchResponse: SearchResponse;
}

interface SetCurrentEmojiTags {
    type: typeof ACTION_SET_CURRENT_EMOJI_TAGS;
    tags: Tag[];
}

interface SetEditingEmojiTags {
    type: typeof ACTION_SET_EDITING_EMOJI_TAGS;
    tags: Tag[];
}

interface setLoadingEmojis {
    type: typeof ACTION_SET_LOADING_EMOJIS;
    loadingEmojis: boolean;
}

interface setLoadingEmojiTags {
    type: typeof ACTION_SET_LOADING_EMOJI_TAGS;
    loadingEmojiTags: boolean;
}

interface SetCurrentEmojiVisualizerName {
    type: typeof ACTION_SET_CURRENT_EMOJI_VISUALIZER_NAME;
    visualizerName: EmojiVisualizerName | null;
    visualizerNameIsLocked?: EmojiVisualizerNameIsLocked;
}

interface SetCurrentEmojiVisualizerFiles {
    type: typeof ACTION_SET_CURRENT_EMOJI_VISUALIZER_FILES;
    visualizerFiles: EmojiVisualizerFiles | null;
}

interface SetCurrentEmojiVisualizerMetadata {
    type: typeof ACTION_SET_CURRENT_EMOJI_VISUALIZER_METADATA;
    visualizerMetadata: EmojiVisualizerMetadata | null;
    visualizerIsLocked?: EmojiVisualizerIsLocked;
}

interface SetCurrentEmojiVisualizerUrl {
    type: typeof ACTION_SET_CURRENT_EMOJI_VISUALIZER_URL;
    currentEmoji: string;
}

interface SetUserRemovedEmojis {
    type: typeof ACTION_SET_USER_REMOVED_EMOJIS;
    removedEmojis: EmojiId[];
}

export type UserEmojiActionTypes =
    | SetUserEmojis
    | SetUserExtendedEmojis
    | SetUserRemovedEmojis
    | SetCurrentUserEmoji
    | SetCurrentUserEmojiSearch
    | SetCurrentEmojiTags
    | SetEditingEmojiTags
    | setLoadingEmojis
    | setLoadingEmojiTags
    | SetCurrentEmojiVisualizerName
    | SetCurrentEmojiVisualizerFiles
    | SetCurrentEmojiVisualizerMetadata
    | SetCurrentEmojiVisualizerUrl;
